import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid, watch_id, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/medicaldocuments/?size=${size}`,
			headers.bearer()
		)
	},
	getAllByCategory (context, user_uid, watch_id, category_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/medicaldocuments/?category=${category_id}`,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id, id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/medicaldocuments/${id}`,
			headers.bearer()
		)
	},
	add (context, user_uid, watch_id, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/${watch_id}/medicaldocuments`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/medicaldocuments/${model.id}`,
			model,
			headers.bearer()
		)
	},
	delete (context, user_uid, watch_id, id) {
		return context.$http.delete(
			`${url}/users/${user_uid}/watches/${watch_id}/medicaldocuments/${id}`,
			headers.bearer()
		)
	},
	// Categories
	categories: {
		getAll (context, offset = 0, size = 999) {
			return context.$http.get(
				`${url}/medicaldocuments/categories/?offset=${offset}&size=${size}`,
				headers.bearer()
			)
		},
		getAllWithDocCount (context, user_uid, watch_id, offset = 0, size = 999) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/medicaldocuments/categories?offset=${offset}&size=${size}`,
				headers.bearer()
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/medicaldocuments.js